import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay, filter, indexOf,
  reduce, truncate, map, concat, uniq, without } from 'lodash';
import { Dropdown, Tooltip, OverlayTrigger, MenuItem } from 'react-bootstrap';
import Fa from 'react-fontawesome';

const typeOptions = [
  { value: 'news', label: 'News' },
  { value: 'newFeature', label: 'New Feature' },
  { value: 'enhancement', label: 'Enhancement' },
  { value: 'resolvedIssue', label: 'Resolved Issue' },
  { value: 'knownIssue', label: 'Known Issue' },
  { value: 'other', label: 'Other' },
];

class TypeDropdown extends Component {
  constructor() {
    super();
    this.state = {
      types: [],
      oldTypes: [],
      dropdownOpen: false,
    };
    this.setType = this.setType.bind(this);
    this.submit = this.submit.bind(this);
    this.setAllType = this.setAllType.bind(this);
  }

  setType(type) {
    const { types } = this.state;
    let newTypes = [...types];
    if (indexOf(newTypes, type) >= 0) {
      newTypes = without(newTypes, type);
    } else {
      newTypes = concat(newTypes, type);
    }
    let selected = uniq(newTypes);
    if (selected.length === typeOptions.length) {
      selected = [];
    }
    this.setState({ types: selected });
  }
  setAllType() {
    this.setState({ types: [] });
  }
  submit() {
    const { types } = this.state;
    if (types.length === 0) {
      this.props.onTypeChange(map(typeOptions, 'value'));
    } else {
      this.props.onTypeChange(types);
    }
  }
  render() {
    const { dropdownOpen, types } = this.state;
    const { availableTypes } = this.props;
    const options = reduce(typeOptions, (items, typeOption) => {
      items.push({
        ...typeOption,
        active: indexOf(types, typeOption.value) >= 0,
        disabled: indexOf(availableTypes, typeOption.value) < 0,
      });
      return items;
    }, []);
    const activeOptions = filter(options, { active: true });
    const isAll = activeOptions.length === 0;

    const activeLabels = map(activeOptions, 'label');
    let activeLabelString = map(typeOptions, 'label').join(' + ');
    if (activeLabels.length > 0) {
      activeLabelString = activeLabels.join(' + ');
    }
    const activeLabelStringShort = truncate(activeLabelString, { length: 20 });
    const tip = (
      <Tooltip id="period-dropdown-tip">
        {activeLabelString}
      </Tooltip>
    );

    return (
      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
        <Dropdown
          id="types-dropdown"
          open={dropdownOpen}
          onToggle={(open, e, s) => {
            if (!dropdownOpen) {
              this.setState({ oldTypes: [...this.state.types], dropdownOpen: true });
            } else if (dropdownOpen && s.source === 'rootClose') {
              this.setState({ dropdownOpen: false });
              delay(() => {
                const remain1 = filter(this.state.types, c => indexOf(this.state.oldTypes, c) < 0);
                const remain2 = filter(this.state.oldTypes, c => indexOf(this.state.types, c) < 0);
                if (remain1.length > 0 || remain2.length > 0) {
                  this.submit();
                }
              }, 100);
            }
          }}
        >
          <Dropdown.Toggle bsSize="small">
            {activeLabelStringShort}
          </Dropdown.Toggle>
          {options.length > 0 &&
            <Dropdown.Menu>
              <MenuItem active={isAll} onSelect={() => { this.setAllType(); }}>
                <Fa name={isAll ? 'check-square-o' : 'square-o'} /> All
              </MenuItem>
              <MenuItem divider />
              {options.map(s => (
                <MenuItem
                  key={s.value}
                  active={s.active}
                  onSelect={() => { this.setType(s.value); }}
                  disabled={s.disabled}
                >
                  <Fa name={s.active ? 'check-square-o' : 'square-o'} /> {s.label}
                </MenuItem>
                ))}

            </Dropdown.Menu>
          }
        </Dropdown>
      </OverlayTrigger>
    );
  }
}

TypeDropdown.propTypes = {
  onTypeChange: PropTypes.func,
  availableTypes: PropTypes.arrayOf(PropTypes.string),
};
TypeDropdown.defaultProps = {
  onTypeChange: () => {},
  availableTypes: [],
};
TypeDropdown.contextTypes = {
  router: PropTypes.object,
};

export default TypeDropdown;
